import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './ui/LoadingComponents';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireMasterAgent?: boolean;
  requireSuperAgent?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireMasterAgent = false,
  requireSuperAgent = false
}) => {
  const { currentUser, currentAgent, loading } = useAuth();
  const location = useLocation();

  // Wait for loading to complete before making any decisions
  if (loading) {
    return <LoadingSpinner message="Loading..." />;
  }

  if (!currentUser) {
    // Redirect to login page with return url
    return <Navigate to="/agent/login" state={{ from: location }} replace />;
  }

  if (!currentAgent) {
    // User is authenticated but not an agent
    return <Navigate to="/agent/unauthorized" replace />;
  }

  if (!currentAgent.isActive) {
    // Agent is deactivated
    return <Navigate to="/agent/deactivated" replace />;
  }

  if (requireSuperAgent && currentAgent.role !== 'super_agent') {
    // Route requires super agent role
    return <Navigate to="/agent/dashboard" replace />;
  }

  if (requireMasterAgent && currentAgent.role !== 'master_agent' && currentAgent.role !== 'super_agent') {
    // Route requires master agent or super agent role
    return <Navigate to="/agent/dashboard" replace />;
  }

  return <>{children}</>;
}; 